import { ReneoLogo } from './reneo-logo';

export function RouteLoader() {
    return (
        <div
            className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white"
            role="status"
            aria-label="Loading Reneo"
            aria-live="polite"
            aria-busy="true"
        >
            <ReneoLogo type="gradient" width={400} className="max-w-[80vw]" />
            <div className="splash-dots" aria-hidden="true">
                <div className="splash-dot" />
                <div className="splash-dot" />
                <div className="splash-dot" />
                <div className="splash-dot" />
                <div className="splash-dot" />
                <div className="splash-dot" />
            </div>
        </div>
    );
}

export default RouteLoader;
